/**
 * @generated SignedSource<<f422be292dc5dd743dd1fec4a735f839>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NodeInput = {
  id: string;
};
export type InternBrandBillingRecurringSubCardDeleteMutation$variables = {
  input: NodeInput;
};
export type InternBrandBillingRecurringSubCardDeleteMutation$data = {
  readonly deletePendingBillingConfig: {
    readonly id: string;
  };
};
export type InternBrandBillingRecurringSubCardDeleteMutation = {
  response: InternBrandBillingRecurringSubCardDeleteMutation$data;
  variables: InternBrandBillingRecurringSubCardDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "input"
      }
    ],
    "concreteType": "GraphQLPendingBillingConfig",
    "kind": "LinkedField",
    "name": "deletePendingBillingConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBrandBillingRecurringSubCardDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBrandBillingRecurringSubCardDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7a92a218ec1d3b2bbb7c592db708be5c",
    "id": null,
    "metadata": {},
    "name": "InternBrandBillingRecurringSubCardDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation InternBrandBillingRecurringSubCardDeleteMutation(\n  $input: NodeInput!\n) {\n  deletePendingBillingConfig(data: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "360544edf42971f8f92165e03c54ae80";

export default node;
